(function(){
    'use strict';

    angular.module('tmx-app')
        .run(['$templateCache', function ($templateCache) {
            $templateCache.put('partials/menu-link.tmpl.html',
                '<md-button ng-if="checkStatePrevilege(section.route)"  id="{{section.name}}" class="colors-menus side-padding-0" ' +
        'ng-class="{\'link-active\' : isActive()}" \n ng-click="open()">\n' +
        '<md-icon class="colors-menus md-background md-hue-3 material-icons margin-top-2 margin-left-8 margin-right-8" ng-class="{\'active\' : isActive()}"  >{{section.icon}}</md-icon>'+
        '  {{section.label | translate }}\n' +
        '</md-button>\n' +
        '');
        }])
    // ng-if="!section.disabledSection"
        .directive('menuLink', ['menu','routes','$state','$translate','ServerExceptionService','tmxUtility','PrevilegeService',
            function (menu,routes,$state,$translate,ServerExceptionService,tmxUtility,PrevilegeService) {
                var directive={
                    scope: {
                        section: '='
                    },
                    templateUrl: 'partials/menu-link.tmpl.html',
                    link: function ($scope, $element, $attributes) {
                        $scope.open=function(){
                            if($scope.section.route == "") {
                                if($scope.section.state != localStorage.getItem('culture')) {
                                    $translate.use($scope.section.state);
                                    localStorage.setItem('culture', $scope.section.state);
                // if($state.current.name.indexOf('edit') > 0 || $state.current.name.indexOf('info')  > 0 || $state.current.name.indexOf('add') > 0)
                                    if($state.current.name == 'private.transaction.loanapplication.edit' || $state.current.name == 'private.transaction.loanapplication.info' || $state.current.name == 'private.transaction.loanapplication.add') {
                                        $state.go($state.current.name, {}, {reload: true});
                                    }
                
                
                                }              
                            }
                            else {
                                menu.selectPage($scope.section);
              // $state.go($state.current.name, {}, {reload: true});
                            }
                        };
                        $scope.checkStatePrevilege = function(stateName){ 
            
                            return PrevilegeService.CheckStatePrevilege("private."+stateName)
                        };

                        $scope.isActive=function(){
                            if($scope.section.route != "") {
                                var newState = "";
                                var route=routes.getRouteByName($scope.section.name);
                                if(!angular.isDefined(route) || route==null)return false;
                                if ($state.current.name.indexOf(".add") > 0 ){
                                    newState = $state.current.name.replace(".add","")
                                }
                                else if($state.current.name.indexOf(".edit") > 0){
                                    newState = $state.current.name.replace(".edit","")
                                }
                                else{
                                    newState = $state.current.name;
                                }               
                                return (($state.current.name==route.state) || (newState==route.state));
                            }
                            else {
                                if($scope.section.state == localStorage.getItem('culture')) {
                                    $translate.use($scope.section.state);
                                    return true;       
                                }                
                                else {
                                    return false;          
                                }
                 
                            }
              
                        };


          // $scope.isActive = function() {
          //     if($scope.active=="true")
          //       return true;
          //     else
          //       return false;
          // };


                        $scope.focusSection = function () {
            // set flag to be used later when
            // $LoggedInUserPrivilegestionChangeSuccess calls openPage()
                            menu.autoFocusContent = true;
                        };
                    }//link function end
                };

                return directive; 
            }])
})();